/** @format */

import { ref } from 'vue'

// 这里根据移动端原生的 userAgent 来判断当前是 Android 还是 ios
const u = navigator.userAgent
// Android终端
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
// IOS 终端
// const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

/**
 * 配合 IOS 使用时的初始化方法
 */
const iosFunction = callback => {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

/**
 * 配合 Android 使用时的初始化方法
 */
const androidFunction = callback => {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function () {
        callback(window.WebViewJavascriptBridge)
      },
      false
    )
  }
}

window.setupWebViewJavascriptBridge = isAndroid ? androidFunction : iosFunction

isAndroid &&
  window.setupWebViewJavascriptBridge(function (bridge) {
    // 注册 H5 界面的默认接收函数（与安卓交互时，安卓端可以不调用函数名，直接 send 数据过来，就能够在这里接收到数据）
    bridge.init(function (msg, responseCallback) {
      console.log(msg)
      responseCallback('JS 返回给原生的消息内容')
    })
  })

const messageListener = ref(msg => {})
window.setupWebViewJavascriptBridge(bridge => {
  bridge.registerHandler('receiveRacingMessage', (data, responseCallback) => {
    messageListener.value(data)
    responseCallback(JSON.stringify({ status: 0 }))
  })
})

function registerHandler(name, callback) {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.registerHandler(name, function (data, responseCallback) {
      console.log('registerHandler:', name)
      messageListener.value(data)
      responseCallback(callback(data))
    })
  })
}

function ucooAlert(msg) {
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({ content: msg })
    bridge.callHandler('ucoo_toast', data, result => {
      console.log(result)
    })
  })
}

function ucooCloseWebview() {
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({})
    bridge.callHandler('ucoo_finish', data, result => {
      console.log(result)
    })
  })
}

function ucooStatusBarHeight(successCB, failCB) {
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({})
    bridge.callHandler('ucoo_status_bar_height', data, result => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        successCB && successCB(resultData.data)
      } else {
        failCB && failCB(resultData.msg)
      }
    })
  })
}

function ucooRequestPermission(scope, successCB, failCB) {
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({ scope: scope })
    bridge.callHandler('ucoo_request_permission', data, result => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        let grantResult = parseInt('' + resultData.data)
        successCB && successCB(grantResult >= 0) // granted
      } else {
        failCB && failCB(resultData.msg)
      }
    })
  })
}

function ucooH5JumpApp(target_name, params, successCB, failCB) {
  // h5跳转APP
  // target_name 字符串，params 参数对象
  console.log('H5JumpApp ' + target_name + JSON.stringify(params))
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({ target_name: target_name, params: params })
    bridge.callHandler('ucoo_h5_jump_app', data, result => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        successCB && successCB(resultData.data)
      } else {
        failCB && failCB(resultData.msg)
      }
    })
  })
}

function ucooSetTitleBar(title, successCB, failCB) {
  // h5跳转APP
  // target_name 字符串，params 参数对象
  console.log('ucooSetTitleBar ' + title)
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify({ title: title })
    bridge.callHandler('ucoo_title_bar', data, result => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        successCB && successCB(resultData.data)
      } else {
        failCB && failCB(resultData.msg)
      }
    })
  })
}

function ucooPay(params, successCB, failCB) {
  console.log('ucoofk ' + JSON.stringify(params))
  window.setupWebViewJavascriptBridge(bridge => {
    let data = JSON.stringify(params)
    bridge.callHandler('ucoo_fk', data, result => {
      let resultData = JSON.parse(result)
      if (resultData.status === 0) {
        successCB(resultData.data)
      } else {
        failCB(resultData.msg)
      }
    })
  })
}

function callClientMethod(event, data, callback) {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler(event, data, callback)
  })
}

export {
  ucooAlert,
  ucooCloseWebview,
  ucooStatusBarHeight,
  ucooRequestPermission,
  ucooH5JumpApp,
  ucooSetTitleBar,
  ucooPay,
  callClientMethod,
  registerHandler,
  messageListener,
}
